import getToken from '../getToken';

const isLoggedIn = () => !!getToken();

export default isLoggedIn;
